import trimExtraSpacesStringUtil from '../trim-spaces'

export default function startCaseStringUtil (str) {
  if (typeof str !== 'string') {
    throw new Error('Input must be a string')
  }

  return trimExtraSpacesStringUtil(
    str.replace(/_/g, ' ')
      .replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
      })
  )
}
